import { Injectable } from '@angular/core';
import {
  FeatureCollectionPoints,
  FeatureCollectionSpans,
  GeoJsonStorageData,
} from './geo-json-storage-entities';

@Injectable({
  providedIn: 'root',
})
export class GeoJsonStorageService {
  localStorageKeyPoints = 'GeoJsonPropertiesPoints';
  loacalStorageKeySpans = 'GeoJsonPropertiesSpans';

  private setLocalStorage<T>(
    key: string,
    ifs: string,
    featureCollection: T,
  ): void {
    const data = JSON.stringify({ ifs, featureCollection });
    localStorage.setItem(key, data);
  }

  private getLocalStorage<T>(key: string): GeoJsonStorageData<T> | null {
    const data = localStorage.getItem(key);
    return data ? (JSON.parse(data) as GeoJsonStorageData<T>) : null;
  }

  private isDataForCurrentIfs<T>(
    ifs: string,
    data: GeoJsonStorageData<T>,
  ): boolean {
    return data.ifs === ifs;
  }

  setPoints = (
    ifs: string,
    featureCollection: FeatureCollectionPoints,
  ): void => {
    this.setLocalStorage(this.localStorageKeyPoints, ifs, featureCollection);
  };

  setSpans = (ifs: string, featureCollection: FeatureCollectionSpans): void => {
    this.setLocalStorage(this.loacalStorageKeySpans, ifs, featureCollection);
  };

  checkForStoredPoints(ifs: string): FeatureCollectionPoints | null {
    const data = this.getLocalStorage<FeatureCollectionPoints>(
      this.localStorageKeyPoints,
    );
    return data && this.isDataForCurrentIfs(ifs, data)
      ? data.featureCollection
      : null;
  }

  checkForStoredSpans(ifs: string): FeatureCollectionSpans | null {
    const data = this.getLocalStorage<FeatureCollectionSpans>(
      this.loacalStorageKeySpans,
    );
    return data && this.isDataForCurrentIfs(ifs, data)
      ? data.featureCollection
      : null;
  }
}
